const peiOtherServMeasures = {
  Regular: 16,
  EvaluacionAlterna: 17,
  NoApplicable: 18,
};

export default peiOtherServMeasures;
